import React from 'react';
import CustomButton from '../ui/Button';
import { useTranslation } from "react-i18next";


const ContactSection = () => {
  const { t,i18n } = useTranslation("home");
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="relative mx-auto px-[30px] max-w-[1220px] mt-[82.53px]">
      <div className="container-bg h-[593px] w-full rounded-lg shadow-lg text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
        <img
          src="/assets/ellipse.svg"
          alt="Ellipse Background"
          className="absolute bottom-20 left-1/2 transform -translate-x-1/2 translate-y-1/2 z-5 opacity-100"
        />
        <div className="relative z-10 flex flex-col justify-center items-center h-full border border-[#FFFFFF1A] rounded-[10px]">
          <div className="title-small font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit">
            <span className="gradient-text">
              {t("future_of_mining")}
            </span>
          </div>
          <div className='max-w-[590px]'>
            <h2 className={`web-heading-card-3 tracking-[-1.2px] text-color-2 mb-4 ${isRussian ? 'lang-ru-web-heading-card-3' : ''}`}>

              {t("safer_mines_smarter_operations")}

            </h2>
            <p className={`body-large-3 text-color mb-6 ${isRussian ? 'lang-ru-body-large-3' : ''}`}>

              {t("optimized_mining_first_step")}

            </p>
          </div>
          <a href="/contact_us">
            <CustomButton className="body-medium">
              {t("contact_us")}

            </CustomButton>
          </a>
        </div>
      </div>
    </div>

  );
};

export default ContactSection;
